import React from "react";
import {
  addToCart,
  addToWishlist,
  addToCompare,
  removeFromWishlist,
  removeFromCompare,
} from "../../../actions";
import { connect } from "react-redux";
import classes from "./search-result-grid.module.scss";
import Item from "../../algolia_listing/components/item";

const SearchResultGrid = (props) => {
  const {
    title,
    addToCart,
    addToWishlist,
    addToCompare,
    removeFromWishlist,
    removeFromCompare,
    wishListItems,
    compareItems,
    searchResults,
    symbol,
    onClick,
  } = props;

  if (!searchResults || searchResults.length === 0) return null;

  return (
    <section className={classes.search_grid_container}>
      <div className="gift-ideas-container">
        <div className={`${classes.heading_section} p-md-0`}>
          <h2 className="heading-title p-0">
            {title ? title : "Trending products"}
          </h2>
        </div>

        <div
          className="uk-grid uk-child-width-1-2 uk-child-width-1-4@s"
          data-uk-grid
        >
          {searchResults.map((item, index) => (
            <div key={index} className="p-0 pr-lg-2">
              <Item
                key={index}
                index={index}
                product={item}
                symbol={symbol}
                onAddToCompareClicked={addToCompare}
                onRemoveFromCompareClicked={removeFromCompare}
                onAddToWishlistClicked={addToWishlist}
                onRemoveFromWishlistClicked={removeFromWishlist}
                onAddToCartClicked={addToCart}
                wishListedItem={wishListItems}
                compareItems={compareItems}
                onClick={onClick}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const mapStateToProps = (state) => ({
  wishListItems: state.wishlist.list,
  compareItems: state.compare.items,
  symbol: state.data.symbol,
});

export default connect(mapStateToProps, {
  addToCart,
  addToWishlist,
  removeFromWishlist,
  addToCompare,
  removeFromCompare,
})(SearchResultGrid);
